module.exports = __webpack_public_path__ + "static/media/square-half.79dad83d.svg";